import { format } from 'date-fns';
import { ru, es, de, enUS } from 'date-fns/locale';
import { ENV } from '@shared/config';

const DATE_LOCALE = {
  ru,
  de,
  en: enUS,
  es,
};

/**
 * Форматирует дату в формате "день месяц прописью год"
 * @param dateString - строка даты в формате YYYY-MM-DD HH:MI:SS
 * @returns отформатированная дата на соответствующем языке
 */
export const formatQuestionDate = (dateString: string): string => {
  try {
    const date = new Date(dateString);
    const locale = DATE_LOCALE[ENV.LANG as keyof typeof DATE_LOCALE] || enUS;
    
    return format(date, 'd MMMM yyyy', { locale });
  } catch (e) {
    console.error('Ошибка форматирования даты:', e);
    return dateString;
  }
}; 